<template>
  <div>
    <div class='doc' v-if="!isLoading">
      <div>
        <h2>Заявление
          о предоставлении дополнительных услуг<br>
          № заявки {{ dg.extended.DemandId }}
        </h2>

      </div>
      <div id="allBoxes">
        <div class="box">
          <div class="leftSide">
            <h3>«СТРАХОВАНИЕ ОТ ПОТЕРИ ТРУДОСПОСОБНОСТИ»</h3>
            <p>Страховое акционерное общество «ВСК» ОГРН 1027700186062 По следующим реквизитам: Страховое акционерное
              общество «ВСК» ИНН 7710026574 ОГРН 1027700186062 р/с40701810600020001241 в ПАО «Сбербанк России», г.
              Москва к/с 30101810400000000225 БИК:044525225</p>
            <p>В сумме {{ pdlBox }} рублей 00 копеек</p>
            <div class="chk">
              <div>
                <input type="checkbox" disabled checked>
                <p>Согласен</p>
              </div>
              <div>
                <input type="checkbox" disabled>
                <p>Не согласен</p>
              </div>
            </div>
          </div>
          <div class="rightSide"> Заключение договора потребительского микрозайма и (или) процентная ставка по потребительскому микрозайму не поставлена в зависимость от приобретения данной услуги.
            Вы вправе отказаться от указанной услуги в течение тридцати календарных дней со дня заключения договора о предоставлении Услуги, посредством обращения в адрес САО «ВСК» по телефону 8-800-775-15-75 и требовать возврата денежных средств, уплаченных за оказание услуги, за вычетом стоимости части такой услуги, фактически оказанной до дня получения САО «ВСК» заявления заемщика об отказе от такой услуги. Предельная дата для такого отказа – 30.11.2023.
            В случае неисполнения САО «ВСК» обязанности по возврату денежных средств, Вы вправе требовать от ООО МКК «ФИНМОЛЛ» возврата денежных средств, уплаченных за оказание услуги, за вычетом стоимости части такой услуги, фактически оказанной до дня получения ООО МКК «ФИНМОЛЛ» или САО «ВСК» заявления заемщика об отказе от такой услуги.
          </div>
        </div>
      </div>

<!--      <section class="section">-->

<!--        <div class="boxes">-->
<!--          <div class="box">-->
<!--            <div class="chk">-->
<!--              <div>-->
<!--                <input type="checkbox" disabled checked>-->
<!--                <p>Согласен</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <input type="checkbox" disabled>-->
<!--                <p>Не согласен</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <h2>«СТРАХОВАНИЕ ОТ ПОТЕРИ ТРУДОСПОСОБНОСТИ»</h2>-->
<!--            <b>Описание услуги:</b>-->
<!--            <p>-->
<!--              Лицо оказывающее услугу: Страховое акционерное общество «ВСК» ОГРН 1027700186062-->
<!--              Платежные реквизиты: Страховое акционерное общество «ВСК» ИНН 7710026574 ОГРН 1027700186062 р/с40701810600020001241 в ПАО «Сбербанк России», г. Москва к/с 30101810400000000225 БИК:044525225-->
<!--              Стоимость услуги: 5000 руб. 00 коп-->
<!--              Заключение договора потребительского микрозайма и (или) процентная ставка по потребительскому микрозайму не поставлена в зависимость от приобретения данной услуги.-->
<!--              Заявитель вправе отказаться от данной услуги в течение тридцати календарных дней со дня выражения настоящего согласия на оказание данной услуги, посредством обращения в адрес ООО «ВСК» по телефону 8-800-775-15-75.-->
<!--            </p>-->
<!--          </div>-->
<!--          <div class="box">-->
<!--            <div class="chk">-->
<!--              <div>-->
<!--                <input type="checkbox" disabled checked>-->
<!--                <p>Согласен</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <input type="checkbox" disabled>-->
<!--                <p>Не согласен</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <h2>«СТРАХОВАНИЕ ОТ ПОТЕРИ ТРУДОСПОСОБНОСТИ»</h2>-->
<!--            <b>Описание услуги:</b>-->
<!--            <p>-->
<!--              Лицо оказывающее услугу: Страховое акционерное общество «ВСК» ОГРН 1027700186062-->
<!--              Платежные реквизиты: Страховое акционерное общество «ВСК» ИНН 7710026574 ОГРН 1027700186062 р/с40701810600020001241 в ПАО «Сбербанк России», г. Москва к/с 30101810400000000225 БИК:044525225-->
<!--              Стоимость услуги: 5000 руб. 00 коп-->
<!--              Заключение договора потребительского микрозайма и (или) процентная ставка по потребительскому микрозайму не поставлена в зависимость от приобретения данной услуги.-->
<!--              Заявитель вправе отказаться от данной услуги в течение тридцати календарных дней со дня выражения настоящего согласия на оказание данной услуги, посредством обращения в адрес ООО «ВСК» по телефону 8-800-775-15-75.-->
<!--            </p>-->
<!--          </div>-->
<!--          <div class="box">-->
<!--            <div class="chk">-->
<!--              <div>-->
<!--                <input type="checkbox" disabled checked>-->
<!--                <p>Согласен</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <input type="checkbox" disabled>-->
<!--                <p>Не согласен</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <h2>«СТРАХОВАНИЕ ОТ ПОТЕРИ ТРУДОСПОСОБНОСТИ»</h2>-->
<!--            <b>Описание услуги:</b>-->
<!--            <p>-->
<!--              Лицо оказывающее услугу: Страховое акционерное общество «ВСК» ОГРН 1027700186062-->
<!--              Платежные реквизиты: Страховое акционерное общество «ВСК» ИНН 7710026574 ОГРН 1027700186062 р/с40701810600020001241 в ПАО «Сбербанк России», г. Москва к/с 30101810400000000225 БИК:044525225-->
<!--              Стоимость услуги: 5000 руб. 00 коп-->
<!--              Заключение договора потребительского микрозайма и (или) процентная ставка по потребительскому микрозайму не поставлена в зависимость от приобретения данной услуги.-->
<!--              Заявитель вправе отказаться от данной услуги в течение тридцати календарных дней со дня выражения настоящего согласия на оказание данной услуги, посредством обращения в адрес ООО «ВСК» по телефону 8-800-775-15-75.-->
<!--            </p>-->
<!--          </div>-->
<!--          <div class="box">-->
<!--            <div class="chk">-->
<!--              <div>-->
<!--                <input type="checkbox" disabled checked>-->
<!--                <p>Согласен</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <input type="checkbox" disabled>-->
<!--                <p>Не согласен</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <h2>«СТРАХОВАНИЕ ОТ ПОТЕРИ ТРУДОСПОСОБНОСТИ»</h2>-->
<!--            <b>Описание услуги:</b>-->
<!--            <p>-->
<!--              Лицо оказывающее услугу: Страховое акционерное общество «ВСК» ОГРН 1027700186062-->
<!--              Платежные реквизиты: Страховое акционерное общество «ВСК» ИНН 7710026574 ОГРН 1027700186062 р/с40701810600020001241 в ПАО «Сбербанк России», г. Москва к/с 30101810400000000225 БИК:044525225-->
<!--              Стоимость услуги: 5000 руб. 00 коп-->
<!--              Заключение договора потребительского микрозайма и (или) процентная ставка по потребительскому микрозайму не поставлена в зависимость от приобретения данной услуги.-->
<!--              Заявитель вправе отказаться от данной услуги в течение тридцати календарных дней со дня выражения настоящего согласия на оказание данной услуги, посредством обращения в адрес ООО «ВСК» по телефону 8-800-775-15-75.-->
<!--            </p>-->
<!--          </div>-->
<!--          <div class="box">-->
<!--            <div class="chk">-->
<!--              <div>-->
<!--                <input type="checkbox" disabled checked>-->
<!--                <p>Согласен</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <input type="checkbox" disabled>-->
<!--                <p>Не согласен</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <h2>«СТРАХОВАНИЕ ОТ ПОТЕРИ ТРУДОСПОСОБНОСТИ»</h2>-->
<!--            <b>Описание услуги:</b>-->
<!--            <p>-->
<!--              Лицо оказывающее услугу: Страховое акционерное общество «ВСК» ОГРН 1027700186062-->
<!--              Платежные реквизиты: Страховое акционерное общество «ВСК» ИНН 7710026574 ОГРН 1027700186062 р/с40701810600020001241 в ПАО «Сбербанк России», г. Москва к/с 30101810400000000225 БИК:044525225-->
<!--              Стоимость услуги: 5000 руб. 00 коп-->
<!--              Заключение договора потребительского микрозайма и (или) процентная ставка по потребительскому микрозайму не поставлена в зависимость от приобретения данной услуги.-->
<!--              Заявитель вправе отказаться от данной услуги в течение тридцати календарных дней со дня выражения настоящего согласия на оказание данной услуги, посредством обращения в адрес ООО «ВСК» по телефону 8-800-775-15-75.-->
<!--            </p>-->
<!--          </div>-->

<!--        </div>-->

<!--        <p>-->
<!--          В случае, если в таблице «Информация об услугах третьих лиц» мною проставлена отметка рядом с услугой, прошу перечислить часть займа в размере, составляющем стоимость дополнительной услуги, третьему лицу, предоставляющему соответствующую услугу.-->
<!--          Я подтверждаю, что правила оказания услуг третьими лицами мне разъяснены и мною получены. Я уведомлен о том, что правила оказания третьими лицами услуг доступны в Личном кабинете заемщика.-->
<!--          Я уведомлен о том, что приобретение услуг третьего лица не влияет на решение кредитора о предоставлении мне займа и на его условия.-->
<!--          Я уведомлен о моем праве отказаться от услуги третьего лица в течение 30 календарных дней со дня выражения мною согласия на ее оказание посредством обращения к третьему лицу, оказывающему дополнительную услугу, с заявлением об отказе от такой услуги.-->
<!--          Я также уведомлен, что вправе требовать от лица, оказывающего дополнительную услугу, возврата денежных средств, уплаченных за оказание такой услуги, за вычетом стоимости части такой услуги, фактически оказанной мне до дня получения лицом, оказывающим такую услугу, моего заявления об отказе от такой услуги. В случае, если третье лицо не исполняет обязанность по возврату мне денежных средств при отказе от дополнительной услуги, я вправе обратиться в ООО МКК «ФИНМОЛЛ» с заявлением о возврате денежных средств при отказе от дополнительной услуги.-->
<!--        </p>-->


<!--&lt;!&ndash;        <signature&ndash;&gt;-->
<!--&lt;!&ndash;            :LastName="dg.ClLastName"&ndash;&gt;-->
<!--&lt;!&ndash;            :FirstName="dg.ClFirstName"&ndash;&gt;-->
<!--&lt;!&ndash;            :MiddleName="dg.ClMiddleName"&ndash;&gt;-->
<!--&lt;!&ndash;            :DemandDate="dg.DemandDate"&ndash;&gt;-->
<!--&lt;!&ndash;            :DataConfirm="dg.DataConfirm"&ndash;&gt;-->
<!--&lt;!&ndash;        ></signature>&ndash;&gt;-->
<!--      </section>-->


    </div>
    <loader v-else></loader>
  </div>
</template>
<script>

export default {
  name: "pdlForm",
  data() {
    return {
      isLoading: true,
      dg:{
        extended:{
          DemandId:'',
          LOAN_WITH_INSURANCE:0
        }
      }
    }
  },
  components: {
    loader :() => import('@/views/pdlloan/uiLoader'),
    // signature: () => import('@/components/other/signature'),
  },
  methods:{
    loadIU(){
      try {
        this.$axios({
          method: 'post',
          url: process.env.VUE_APP_URL_LOAN,
          data: {
            action:'getIU',
            token:this.$route.params.token,
            session_id:this.$route.params.session_id
          }
        }).then(res=>{
          try {
            if (res.data.result.extended !== undefined) {
              res.data.result.extended = JSON.parse(res.data.result.extended);
            }
          } catch (e) {
            console.log(e)
          }
          this.dg = Object.assign(this.dg, res.data.result);
        }).catch(res=>{
          console.log(res);
          alert('Ошибка формирования иу sid='+ this.$route.params.session_id)
        });
      } catch (e) {
        alert('Ошибка формирования иу sid='+ this.$route.params.session_id)
      }
    }
  },
  computed:{
    pdlBox(){
      let out = 0;
      if(this.dg.extended.LOAN_WITH_INSURANCE == 1){
        let step = 1000;
        let boxSumm = 0;
        let exitValue = 15000;
        while(step < exitValue){
          boxSumm = step * 0.1;
          if(step + boxSumm === parseInt(this.dg.extended.pdlGetSelectedDeal.Amount, 10)) {
            out = boxSumm;
            step = exitValue
          }
          step+=1000;
        }
      }
      return out;
    },
  },
  mounted() {
    this.isLoading = false;
    this.loadIU();
  },

}
</script>

<style scoped>
.boxes { display: flex; flex-wrap: wrap }
/*.boxes>.box { width: 47.8%; padding: 10px; border: 1px solid black }*/
.chk>div { display: flex }
.doc {background: white;  padding: 60px;width: 1000px; font-size: 15px; margin: auto;}
.doc>div>h2 { text-align: center; }
#t1, #t2, #t3 {border-collapse: collapse;min-width: 600px;width: 100%;}
#t1 tr {}
#t1 tr td {border: 1px solid #0f5740;padding: 5px}
#t3 tr td {border: 1px solid #0f5740;padding: 5px}
#t2 > tr > td {border: 1px solid #0f5740;padding: 5px}
#t1 tr td:nth-child(1) {width: 5%;text-align: start;vertical-align: top;}
#t1 tr td:nth-child(2) {width: 40%;vertical-align: top;}
#t1 tr td:nth-child(3) {width: 55%;}
#t3 > tr:nth-child(4) > td:nth-child(2) {padding: 0}
#t3 > tr:nth-child(4) > td:nth-child(2) > table{border-collapse: collapse;width: 100%;}
.flex{display: flex;justify-content: space-between;}
.costTable{text-align: end; width: 67%;}
.inf > div:first-child{padding-bottom: 24px;}
h2{font-size: 15px}
input{margin:0  5px}



#allBoxes h3 {margin: 0;font-size: 16px}
#allBoxes .box {display: flex;border: 1px solid #000;page-break-inside: avoid;border-bottom: none}
#allBoxes .box:last-child {border-bottom: 1px solid #000}
#allBoxes .box > .leftSide {border-right: 1px solid #000;padding: 10px}
#allBoxes .box > .rightSide {padding: 10px}
#allBoxes .box>div {width: 50%}
</style>